@if (loaderService.isLoading$ | async) {
    <div  class="overlay">
      <div class="spinner"></div>
    </div>
}



